import styled from 'styled-components';

import grid from '~/styles/grid';

export const Container = styled.div`
  #canvas {
    width: 100%;
  }

  .highlight:not(.djs-connection) .djs-visual > :nth-child(1) {
    fill: rgb(187, 222, 251) !important;
    stroke: rgb(30, 136, 229) !important;
    outline: 2px solid rgb(30, 136, 229);
    border-radius: 11px;
    outline-offset: 5px;
  }

  .previousTasksHighlight:not(.djs-connection) .djs-visual > :nth-child(1) {
    stroke: #8d8d8d !important;
  }

  .previousTasksHighlight:not(.djs-connection) .djs-visual {
    fill: #8d8d8d !important;
    path {
      fill: #fff !important;
      stroke: #8d8d8d !important;
    }

    .djs-label {
      fill: #8d8d8d !important;
    }
  }

  .deletedTasksHighlight:not(.djs-connection) .djs-visual > :nth-child(1) {
    fill: #ffcfd4 !important;
    stroke: #e53935 !important;
  }

  .bjs-container {
    min-height: 450px;
    height: 100%;
    min-width: 892px;
    padding: 8px;
  }

  .bjs-container:not(:first-child) {
    display: none;
  }

  a {
    display: none;
  }

  .zoomControl {
    z-index: 1;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    margin: 0 0 12px -48px;
    height: ${() =>
      `calc(100vh - 80px - 2.357rem - ${grid.md} - ${grid['7xl']})`};

    button {
      border: 1px solid black;
      border-radius: 5px;
      margin-bottom: 8px;
      width: 32px;
      height: 32px;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
`;

export const Loading = styled.div`
  position: absolute;
  left: 50%;
  top: 40%;
  height: 60px;
  width: 60px;
  margin: 0px auto;
  -webkit-animation: rotation 0.6s infinite linear;
  -moz-animation: rotation 0.6s infinite linear;
  -o-animation: rotation 0.6s infinite linear;
  animation: rotation 0.6s infinite linear;
  border-left: 4px solid rgba(235, 0, 49, 0.15);
  border-right: 4px solid rgba(235, 0, 49, 0.15);
  border-bottom: 4px solid rgba(235, 0, 49, 0.15);
  border-top: 4px solid rgba(235, 0, 49, 0.8);
  border-radius: 100%;
  overflow: unset;

  @-webkit-keyframes rotation {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(359deg);
    }
  }
  @-moz-keyframes rotation {
    from {
      -moz-transform: rotate(0deg);
    }
    to {
      -moz-transform: rotate(359deg);
    }
  }
  @-o-keyframes rotation {
    from {
      -o-transform: rotate(0deg);
    }
    to {
      -o-transform: rotate(359deg);
    }
  }
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;
